// extracted by mini-css-extract-plugin
export default {"title":"LabelTitle_title__f5Bd8"};